import React, { FunctionComponent } from 'react'
import { HandleExternalLink } from '../utils/HandleExternalLink'

interface CircularIconProps {
  label?: string
  image?: string
  Icon?: any
  url: string
  videoCount?: number
}

const CircularIcon: FunctionComponent<CircularIconProps> = ({
  label,
  image,
  Icon,
  url,
  videoCount,
}) => (
  <HandleExternalLink to={url} data-testid="external-link">
    <div className="ecommerceIcon-wrapper">
      <div>
        {!!image && (
          <img
            src={image}
            alt="video-thumbnail"
            className="ecommerceIcon-thumbnail"
            data-testid="video-image"
          />
        )}
        {!!Icon && <Icon />}
      </div>
      {!!label && <p className="ecommerceIcon-title">{label}</p>}
      {!!videoCount && (
        <p className="ecommerceIcon-video-count" data-testid="video-count">
          {videoCount} videos
        </p>
      )}
    </div>
  </HandleExternalLink>
)

export default CircularIcon
